// Experience data for the Experience page
export const experienceList = [
  {
    org: "xTerra Robotics",
    date: "Aug 2025 – Present",
    role: "Robotics Software Development Intern",
    loc: "Kanpur, India",
    points: [
      "Architected a joint and Cartesian impedance control framework in C++ and ROS 2 for stable posture regulation and compliant task-space manipulation of a 5-DOF robotic arm.",
      "Modeled a wrench disturbance term that maps manipulator-induced forces to a floating-base whole-body controller, ensuring quadruped stability during dynamic loco-manipulation.",
      "Led design and development of a kinematic model and performed link-length optimisation for a 7-DOF redundant manipulator intended for space applications."
    ],
    links: [
      {
        label: "GitHub Repository",
        url: "https://github.com/shreehank22/Drone-Dog-Solution"
      }
    ]
  },
  {
    org: "Bhatiyani Astute Intelligence Limited",
    date: "Mar 2025 – Jul 2025",
    role: "Project Intern",
    loc: "Bengaluru, India",
    points: [
      "Prepared image and video datasets using CVAT for computer vision tasks through annotation, preprocessing, and augmentation.",
      "Trained and fine-tuned YOLOv5 models for object detection and classification of inventory items in warehouses; evaluated performance using mAP and F1-score."
    ],
    links: [
      {
        label: "Project Docs (Google Drive)",
        url: "https://drive.google.com/drive/folders/1qIiYOlbZnRS4QoxvRCaJ2MiBdvF2LUM5"
      }
    ]
  }
];

export const extracurricularList = [
  {
    org: "SENSORS, NIT Trichy",
    date: "Jul 2025 – Feb 2026",
    role: "Chairperson",
    location: "Tiruchirappalli, India",
    points: [
      "Led planning, coordination, and execution of SENSORS — the national-level technical symposium of the Instrumentation & Control Department, NIT Trichy.",
      "Organised events and guest lectures, delivering a high-impact technical and networking platform for students, industry professionals, and researchers."
    ]
  },
  {
    org: "PSI Racing Team — NIT Trichy",
    date: "Aug 2023 – Aug 2024",
    role: "Engineer — Fabrication & Design",
    location: "Tiruchirappalli, India",
    points: [
      "Lectured on vehicle dynamics and hands-on fabrication methods for 100+ undergraduates.",
      "Contributed to suspension and steering design for the team's all-terrain vehicle."
    ]
  }
];
